/* eslint no-shadow: ["error", { "allow": ["state"] }] */

// Импорт генератора продаж
import { GENERATE_SALES } from '../../actions.type'
import {
  SET_SALES_ALL_REQUEST,
  SET_SALES_ALL_VALUE
} from '../../mutations.type'
import { generateRandomSales } from './utils/salesGenerator'

/**
 * Store модуль для данных продаж телеметрии
 * Используется для централизованного хранения и генерации данных продаж
 */
const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  salesAllValue: (state) => state.all.value,
  salesAllRequest: (state) => state.all.request,
  salesIsLoading: (state) => state.all.request.isLoading,
  salesIsError: (state) => state.all.request.isError || state.all.request.isFatalError
}

const actions = {
  /**
   * Генерирует случайные данные продаж для телеметрии
   * @param {Object} params - Параметры генерации
   * @param {Number} params.count - Количество продаж (по умолчанию 3000)
   * @param {Number} params.daysBack - Дней назад (по умолчанию 365)
   * @param {Boolean} params.isReload - Перезагрузить данные
   */
  async [GENERATE_SALES]({ commit, state, rootGetters }, params = {}) {
    // Если данные уже загружены и не запрошена перезагрузка - выходим
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }

    try {
      // Устанавливаем статус загрузки
      commit(SET_SALES_ALL_REQUEST, {
        isLoading: true,
        isError: false,
        isFatalError: false
      })

      // Получаем необходимые данные
      // equipments и beverages передаются из компонентов (моковые данные)
      const equipments = params.equipments || []
      const beverages = params.beverages || []
      // clients и locations берем из store
      const clients = rootGetters.clientAllValue || []
      const locations = rootGetters.locationAllValue || []

      // Проверяем наличие всех необходимых данных
      const missingData = []
      if (equipments.length === 0) missingData.push('equipments')
      if (beverages.length === 0) missingData.push('beverages')
      if (clients.length === 0) missingData.push('clients')
      if (locations.length === 0) missingData.push('locations')

      if (missingData.length > 0) {
        // Не выбрасываем ошибку, просто логируем и выходим
        // Данные загрузятся позже и watch вызовет генерацию снова
        // eslint-disable-next-line no-console
        commit(SET_SALES_ALL_REQUEST, {
          isLoading: false,
          isError: false
        })
        return
      }

      // Имитация задержки для демонстрации loader (убрать в production)
      await new Promise(resolve => setTimeout(resolve, 500))

      // Генерируем данные продаж
      const sales = generateRandomSales({
        count: params.count || 3000,
        equipments,
        beverages,
        clients,
        locations,
        daysBack: params.daysBack || 365
      })

      // Устанавливаем успешный статус и сохраняем данные
      commit(SET_SALES_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true,
        isError: false
      })
      commit(SET_SALES_ALL_VALUE, sales)
    } catch (e) {
      // В случае ошибки устанавливаем статус ошибки
      commit(SET_SALES_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false,
        isError: true
      })
      console.error('Error generating sales:', e)
    }
  }
}

const mutations = {
  [SET_SALES_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_SALES_ALL_VALUE](state, sales) {
    state.all.value = sales
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
